import React from 'react';
import CardBaseInput from './CardBaseInput';
import { emailValidator } from '../../helpers/validators';

class CardEmailInput extends CardBaseInput {
  constructor(props) {
    super(props);
    this.handleChangeEmailAddress = this.handleChangeEmailAddress.bind(this);
  }

  handleChangeEmailAddress(props = {}) {
    return e => {
      const emailAddress = e.target.value || '';
      this.setInputTouched(false);

      const { onChange = () => {} } = props;
      onChange && onChange(emailAddress);

      const invalidEmail = !emailValidator(emailAddress);
      if (invalidEmail) {
        onChange && onChange('');
      }

      let error = invalidEmail ? 'Invalid Email address' : '';
      this.setError(error);
    };
  }

  render() {
    const { onCardChange, ...rest } = this.props;
    const props = {
      'aria-label': 'Email Address',
      autoComplete: 'email',
      id: 'email',
      name: 'email',
      placeholder: 'Email Address',
      type: 'text',
      ...rest,
      onBlur: this.handleBlurInput(this.props),
      onChange: this.handleChangeEmailAddress(this.props),
    };

    const { touched, error } = this.state;

    return (
      <div className="input-area">
        <input {...props} />
        <div className="error-view">{touched && error}</div>
      </div>
    );
  }
}

export default CardEmailInput;
